// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__ZJ11y","emails":"CreateEditClinics_emails__1_E9n","emailTagLabel":"CreateEditClinics_emailTagLabel__1a-EQ"};